import { motion } from "framer-motion";
import { Star, BadgeCheck } from "lucide-react";
import { SectionHead, staggerContainer, staggerItem } from "../Reveal";
import { REVIEWS } from "../../data/site";

const Stars = () => (
  <div className="flex gap-0.5">
    {[...Array(5)].map((_, i) => (
      <Star key={i} className="w-4 h-4 text-orange-400 fill-orange-400" />
    ))}
  </div>
);

export const Reviews = () => (
  <section id="reviews" data-testid="reviews-section" className="relative py-20 sm:py-28 bg-[#04070F]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHead
        eyebrow="Student Reviews"
        title={
          <>
            What Our <span className="text-gradient-orange">Students Say</span>
          </>
        }
      />

      <div className="grid lg:grid-cols-[0.9fr_2fr] gap-6 items-stretch">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          data-testid="rating-summary"
          className="rounded-2xl border border-sky-500/25 bg-[#0B1226] p-8 flex flex-col items-center justify-center text-center"
        >
          <span className="w-14 h-14 rounded-2xl bg-orange-500/15 border border-orange-500/40 flex items-center justify-center mb-4">
            <BadgeCheck className="w-7 h-7 text-orange-400" />
          </span>
          <p className="font-display text-5xl font-extrabold text-white">{REVIEWS.rating}</p>
          <Stars />
          <p className="mt-3 text-sm font-semibold text-slate-300">{REVIEWS.total}</p>
          <p className="mt-1 text-xs text-slate-500">{REVIEWS.badge}</p>
        </motion.div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="grid sm:grid-cols-2 gap-6"
        >
          {REVIEWS.reviews.map((r) => (
            <motion.article
              key={r.name}
              variants={staggerItem}
              data-testid={`review-${r.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="rounded-2xl border border-sky-500/20 bg-[#0B1226] p-6 hover:border-sky-400/40 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <span className="w-9 h-9 rounded-full bg-blue-600/30 border border-sky-500/30 flex items-center justify-center font-display font-bold text-sky-300 text-sm">
                    {r.name[0]}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-white">{r.name}</p>
                    <p className="text-[11px] text-slate-500">{r.time}</p>
                  </div>
                </div>
                <Stars />
              </div>
              <p className="text-sm text-slate-400 leading-relaxed">{r.text}</p>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </div>
  </section>
);
